<form [formGroup]="form" (ngSubmit)="onProceedClick()">
  <div class="d-flex justify-content-between align-items-center my-2">
    <div class="d-flex align-items-center">
      <img
        src="assets/images/random_assets/process_payment_icon.png"
        alt="process_payment_icon"
      />
      <div class="card-sub-heading ml-3 bold">Process Payment</div>
    </div>
    <div (click)="continue()">
      <button mat-icon-button (click)="dialogRef.close()" type="button" [disabled]="isLoading">
        <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
      </button>
    </div>
  </div>
  <ng-container *ngIf="!result.isResult; else resultBlock">
    <div class="mt-4">
      <div class="border-bottom p-2" *ngIf="emptyUsers.length > 0">
        <div class="d-flex justify-content-between">
          <div>
            <strong>
              Please note that: Email doesn't exist in following orders so it
              cannot be reflected in Rxdash:
            </strong>
          </div>
        </div>
        <div
          class="d-flex justify-content-between px-3"
          *ngFor="let item of emptyUsers"
        >
          <div class="pb-3">
            <strong> Order ID:</strong>
            {{ item.OrderID }} ({{ item.FirstName }} {{ item.LastName }})
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between border-bottom p-2">
        <div>Orders Selected</div>
        <div>{{ props.orders.length }}</div>
      </div>

      <div class="d-flex justify-content-between border-bottom p-2">
        <div>Orders With Pending Payment</div>
        <div>{{ countPendingOrders.length }}</div>
      </div>

      <div class="d-flex justify-content-between border-bottom p-2">
        <div>Orders With Pay Now</div>
        <div>{{ ordersWithPayNow }}</div>
      </div>
    </div>
    <mat-checkbox
      class="example-margin bold mt-3 ml-3"
      (change)="onCheckChange($event)"
      formControlName="NotifyUsers"
    >
      Notify Users
    </mat-checkbox>
    <div class="row p-3" *ngIf="form.value.NotifyUsers">
      <div class="col-md-12">
        <div class="d-flex row py-3">
          <ng-container formArrayName="NotifyUsersBy">
            <ng-container
              *ngFor="let item of notifyByArray.controls; let i = index"
            >
              <ng-container [formGroupName]="i">
                <div class="col-md-4">
                  <mat-checkbox
                    value="{{ item.value.id }}"
                    [disabled]="item.value.disable"
                    formControlName="isChecked"
                    >{{ item.value.value }}
                  </mat-checkbox>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <app-error-message
            [formName]="form"
            [fieldName]="'NotifyUsersBy'"
            [type]="'group'"
          >
          </app-error-message>
        </div>
      </div>
    </div>
    <div class="d-flex mt-3">
      <div class="col-md-12 d-flex justify-content-center">
        <button
          class="custom-btn w-100"
          (click)="dialogRef.close()"
          type="button"
          [disabled]="isLoading"
        >
          Cancel
        </button>
        <button class="custom-btn w-100" type="submit" [disabled]="isLoading">
          {{ isLoading ? 'Processing...' : 'Proceed' }}
          <span class="whiteLoader" *ngIf="isLoading">&nbsp;</span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #resultBlock>
    <div class="ml-3 my-3">
      <div class="card-sub-heading">Result!</div>
    </div>

    <ng-container *ngIf="result.pendingPayments.length > 0">
      <div class="d-flex justify-content-between px-3 py-3">
        <div>Following orders are in pending payments:</div>
      </div>
      <div
        class="d-flex justify-content-between px-3"
        *ngFor="let item of result.pendingPayments"
      >
        <div class="pb-3">
          <strong> Order ID:</strong>
          {{ item.OrderID }} ({{ item.UserName }}): {{ item.message }}
        </div>
      </div>
    </ng-container>
    <hr />
    <ng-container *ngIf="result.processedPayments.length > 0">
      <div class="d-flex justify-content-between px-3 py-3">
        <div>Following payments are processed:</div>
      </div>
      <div
        class="d-flex justify-content-between px-3"
        *ngFor="let item of result.processedPayments"
      >
        <div class="pb-3">
          <strong> Order ID:</strong>
          {{ item.OrderID }} ({{ item.UserName }})
        </div>
      </div>
    </ng-container>

    <div class="d-flex mt-3">
      <div class="col-md-12 d-flex justify-content-center" (click)="continue()">
        <button class="custom-btn w-100" type="button">Continue</button>
      </div>
    </div>
  </ng-template>
</form>
